import type {
  AutoConfiguratorState,
  ValueId,
} from '@snap-types/models/auto-configurator/state';
import {
  getBooleanValue,
  getDecimalValue,
  getDescriptionValue,
  getNumberValue,
  getSelectValue,
  getTextValue,
  getValue,
} from '@ui/features/alpha/logic/value';

export function selectValue(state: AutoConfiguratorState, valueId: ValueId) {
  return getValue(state, valueId);
}

export function selectDecimalValue(
  state: AutoConfiguratorState,
  valueId: ValueId,
) {
  return getDecimalValue(state, valueId);
}

export function selectNumberValue(
  state: AutoConfiguratorState,
  valueId: ValueId,
) {
  return getNumberValue(state, valueId);
}

export function selectSelectValue(
  state: AutoConfiguratorState,
  valueId: ValueId,
) {
  return getSelectValue(state, valueId);
}

export function selectTextValue(
  state: AutoConfiguratorState,
  valueId: ValueId,
) {
  return getTextValue(state, valueId);
}

export function selectDescriptionValue(
  state: AutoConfiguratorState,
  valueId: ValueId,
) {
  return getDescriptionValue(state, valueId);
}

export function selectBooleanValue(
  state: AutoConfiguratorState,
  valueId: ValueId,
) {
  return getBooleanValue(state, valueId);
}
